// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"0241e942","256":"17713501","395":"eebf0948","455":"ed45e55e","659":"b3827e67","899":"ade65084","977":"4a8016a4"}[chunkId] + ".chunk.js";
};